import {Card} from "primereact/card";
import {Button} from "primereact/button";
import {useExam} from "../../contexts/ExamContext";
import React from "react";


const ExamStart = ({onStart}) => {
    const {exam} = useExam();

    const formatDate = (value) => {
        if (!value) return null;
        const d = value instanceof Date ? value : new Date(value);
        return isNaN(d.getTime()) ? null : d.toLocaleString('tr-TR');
    };
    const tableStyle = {width: "100%", borderCollapse: "collapse", textAlign: "left"};
    const thClass = "border-1 surface-border p-2 w-4 font-medium text-600 surface-100";
    const tdClass = "border-1 surface-border p-2 font-bold";

    return (
        <Card className="p-6 w-[400px] text-center" style={{width: "40%", minHeight: "400px"}}>
            <h2 className="text-xl font-bold mb-2">{exam?.title}</h2>
            <p className="text-color mb-4">{exam?.description}</p>

            <table style={tableStyle}>
                <tbody>
                {exam?.durationMinutes &&
                    <tr>
                        <td className={thClass}>Süre</td>
                        <td className={tdClass}> {`${exam?.durationMinutes} dakika`}</td>
                    </tr>
                }
                {(exam?.questionCount && exam?.questionCount !== 0) &&
                    <tr>
                        <td className={thClass}>Soru Sayısı</td>
                        <td className={tdClass}>{`${exam?.questionCount}`}</td>
                    </tr>
                }
                {exam?.passPercent &&
                    <tr>
                        <td className={thClass}>Geçme Yüzdesi</td>
                        <td className={tdClass}>{`%${exam?.passPercent}`}</td>
                    </tr>
                }
                {exam?.startDate &&
                    <tr>
                        <td className={thClass}>Başlangıç Tarihi</td>
                        <td className={tdClass}>{formatDate(exam?.startDate)}</td>
                    </tr>
                }
                {exam?.endDate &&
                    <tr>
                        <td className={thClass}>Bitiş Tarihi</td>
                        <td className={tdClass}>{formatDate(exam?.endDate)}</td>
                    </tr>
                }
                </tbody>
            </table>

            <Button label="Sınava Başla" className="mt-4 w-full" onClick={onStart}/>
        </Card>
    );
};

export default ExamStart;
